import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Button} from '@betareader/design-system';
// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  updateCommentFilters
} from '../../../modules/comment';
import {
  fetchStats
} from '../../../modules/book';

import FeedbackSearch from './feedbackSearch';


export class FeedbackFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {

  }

  handleStatusChange = (event) => {
    const updatedFilters = [...this.props.commentFilters];
    const {value, checked} = event.target;
    const index = updatedFilters.indexOf(value);
    if (checked && index < 0) {
      updatedFilters.push(value);
    } else if (!checked && index >= 0) {
      updatedFilters.splice(index, 1);
    }
    this.props.updateCommentFilters(updatedFilters);
  }

  clearFilters = () => {
    this.props.updateCommentFilters([]);
  }

  render() {
    const { commentFilters, t } = this.props;
    return (
      <div className="br-feedback-filters">
        <Button variant="secondary" size="small" onClick={this.clearFilters}>{t('RemoveFilters')}</Button>
        <fieldset>
          <legend>{t('ShowOnly')}</legend>
          {['NEW', 'TODO', 'DOING', 'DONE', 'IGNORE'].map(status => (
            <label key={status}>
              <input type="checkbox" value={status}
                checked={commentFilters.includes(status)}
                onChange={this.handleStatusChange} />
              {t(`Status${status}`)}
            </label>
          ))}
        </fieldset>
        <div>
          <FeedbackSearch />
        </div>
      </div>
    )
  }
}

// redux stuff
const mapStateToProps = state => ({
  idToken: state.user.idToken,
  readers: state.book.readers,
  chapters: state.book.parts,
  stats: state.book.stats,
  currentBook: state.book.currentBook,
  commentFilters: state.comment.filters
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchStats,
  updateCommentFilters,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackFilter)))
